// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.ToggleButton_dashboard__6uIAT {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.ToggleButton_dashboardContain__G3Iom {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_dashboardContain__G3Iom,
.ToggleButton_bodythemedark__mk1cl .ToggleButton_dashboard__6uIAT,
.ToggleButton_bodythemedark__mk1cl .ToggleButton_cont2__y79\\+w {
  background-Color: #0f1824;
}

.ToggleButton_top_header__Cqcd3 .ToggleButton_top_header_inner__Uy0t5 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.ToggleButton_cont2__y79\\+w {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.ToggleButton_subLink__qrmnO svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.ToggleButton_footer__k\\+jkH {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.ToggleButton_bodythemelight__xbVdb {
  background-color: #fff;
  padding-top: 90px;
}

.ToggleButton_bodythemedark__mk1cl {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.ToggleButton_headerthemelight__KBxNK {
  background-color: #fff;
}

.ToggleButton_headerthemedark__6P1qs {
  background-color: #132337;
}

.ToggleButton_top_header__Cqcd3 {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.ToggleButton_menuthemelight__Um682 {
  background-color: #fff;
}

.ToggleButton_menuthemedark__VX9a7 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.ToggleButton_menulinklight__fo-41 span {
  color: #666666 !important;
}

.ToggleButton_menulinklight__fo-41 a {
  color: #CBCBCB !important;
}

.ToggleButton_menulinklight__fo-41:hover span, .ToggleButton_menulinklight__fo-41:hover a {
  color: #fff !important;
}

.ToggleButton_menulinkdarkSelected__v5Q2p {
  background-color: #1c2e45;
  color: #3b82f6;
}

.ToggleButton_menuthemelight__Um682 .ToggleButton_menulinklightSelected__p-O0O {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.ToggleButton_menulinkdark__H9koF {
  color: #92afd3 !important;
}

.ToggleButton_menulinklight__fo-41:hover {
  color: #fff !important;
  background-color: #131F43;
}

.ToggleButton_menulinklight__fo-41 .ToggleButton_sub_arrow__3tNzG svg path {
  stroke: #CBCBCB !important;
}

.ToggleButton_menulinklight__fo-41:hover .ToggleButton_sub_arrow__3tNzG svg path {
  stroke: #fff !important;
}

.ToggleButton_menulinkdark__H9koF .ToggleButton_sub_arrow__3tNzG svg path {
  stroke: #92afd3 !important;
}

.ToggleButton_menulinkdark__H9koF:hover .ToggleButton_sub_arrow__3tNzG svg path {
  stroke: #fff !important;
}

.ToggleButton_menulinkdark__H9koF:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.ToggleButton_headinglight__46yE4 {
  color: #60677e;
}

.ToggleButton_headingdark__7Kdz4 {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.ToggleButton_searchboxlight__IgyaT {
  background-color: #fff;
  border: none;
}

.ToggleButton_searchboxdark__s-55U {
  background-color: #132337;
  color: #fff;
  border: none;
}

.ToggleButton_searchboxdark__s-55U::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.ToggleButton_tableheadlight__HMlEb {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.ToggleButton_tableheadlight__HMlEb th {
  color: #fff;
}

thead .ToggleButton_tableheadlight__HMlEb th:first-child,
thead .ToggleButton_tableheaddark__CqMs1 th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .ToggleButton_tableheadlight__HMlEb th:last-child,
thead .ToggleButton_tableheaddark__CqMs1 th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.ToggleButton_table__gUUsS.ToggleButton_table-borderless__eH6QQ {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.ToggleButton_tableheaddark__CqMs1 {
  background-color: #132337;
  color: #fff;
}

.ToggleButton_table-borderless__eH6QQ tr:nth-child(even) {
  background-color: #F9FAFB;
}

.ToggleButton_table-borderless__eH6QQ .ToggleButton_left-section__meX0e {
  padding-top: 10px;
}

.ToggleButton_tablebodylight__CqriS td,
.ToggleButton_tablebodydark__9ZXJj td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.ToggleButton_tablebodylight__CqriS {
  background-color: #fff;
}
.ToggleButton_tablebodylight__CqriS:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.ToggleButton_tablebodydark__9ZXJj {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.ToggleButton_tablebodydark__9ZXJj:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.ToggleButton_paginationlight__BaJSK {
  color: #60677e !important;
  font-size: 13px !important;
}

.ToggleButton_paginationdark__fwOiV {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.ToggleButton_formthemelight__WUeV2 {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.ToggleButton_formthemedark__CPoir {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.ToggleButton_formthemedark__CPoir ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.ToggleButton_viewformlight__kVJ4n {
  background-color: #f3f6f9;
}

.ToggleButton_permissionboxlight__gxJYP {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.ToggleButton_permissionboxdark__HAgO2 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.ToggleButton_errormsgclr__Lb-s- {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.ToggleButton_graphclrlight__CuUx3 {
  background-color: #fff;
}

.ToggleButton_graphclrdark__pHaGO {
  background-color: #132337;
}

/* 
Counter theme
*/
#ToggleButton_card1bglight__cN6YD {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#ToggleButton_card1bgdark__dKi5L {
  background: #392f28;
}

#ToggleButton_card2bglight__Yvkl4 {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#ToggleButton_card2bgdark__0vB9u {
  background: #1c3238;
}

#ToggleButton_card3bglight__Kqqmv {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#ToggleButton_card3bgdark__siCXv {
  background: #3a2434;
}

#ToggleButton_card4bglight__yPfuZ {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#ToggleButton_card4bgdark__KQ3Jn {
  background: #2f264f;
}

#ToggleButton_card1bgdark__dKi5L a, #ToggleButton_card1bgdark__dKi5L p,
#ToggleButton_card2bgdark__0vB9u a, #ToggleButton_card2bgdark__0vB9u p,
#ToggleButton_card3bgdark__siCXv a, #ToggleButton_card3bgdark__siCXv p,
#ToggleButton_card4bgdark__KQ3Jn a, #ToggleButton_card4bgdark__KQ3Jn p {
  color: #fff;
}

/* 
Action button theme
*/
.ToggleButton_actionbtnlight__74r4t {
  color: rgba(70, 71, 91, 0.8705882353);
}

.ToggleButton_actionbtnlight__74r4t:hover {
  cursor: pointer;
}

.ToggleButton_actionbtndark__n\\+blE {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.ToggleButton_profiledropdownlight__i75Et {
  background-color: #fff;
}

.ToggleButton_profiledropdowndark__ydRyq {
  background-color: #151521;
}

.ToggleButton_settingsection__qgzvg #ToggleButton_addform__P2xOP.ToggleButton_formthemedark__CPoir .ToggleButton_savebtn__TXAnP {
  background-color: #3b82f6;
  color: #fff;
}

#ToggleButton_addform__P2xOP.ToggleButton_formthemedark__CPoir .ToggleButton_savebtn__TXAnP {
  background-color: #3b82f6;
  color: #fff;
}

.ToggleButton_profile_conatiner__mcUet {
  border-radius: 5px !important;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_ag-theme-alpine__6B\\+er .ToggleButton_ag-row__oz\\+e\\+ {
  background: #000 !important;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_formbtn__PHUbN {
  background-color: #3b82f6;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_formbtn__PHUbN:hover {
  background-color: #2563eb;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_resetbtn__V-tkS {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_resetbtn__V-tkS:hover {
  background-color: #3b82f6;
}

.ToggleButton_headingdark__7Kdz4 span {
  background-color: #132337;
}

.ToggleButton_resetbtn__V-tkS {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.ToggleButton_resetbtn__V-tkS:hover,
.ToggleButton_resetbtn__V-tkS:active,
.ToggleButton_resetbtn__V-tkS:focus {
  background-color: #131F43;
  color: #fff;
}

.ToggleButton_addBtn__SvaL8 {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.ToggleButton_addbtnlight__hhs0R {
  background-color: #38A169;
}

.ToggleButton_addbtndark__MRXDH {
  background-color: #3b82f6;
}

.ToggleButton_addbtndark__MRXDH:hover {
  background-color: #2563eb;
}

.ToggleButton_formthemedark__CPoir label {
  color: #92afd3;
}

.ToggleButton_addBtn__SvaL8 svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.ToggleButton_addBtn__SvaL8:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.ToggleButton_cust_addBtn__Gm3LP.ToggleButton_addBtn__SvaL8 svg {
  top: 2px;
}

.ToggleButton_deleteBtn__T5P7S {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.ToggleButton_deleteBtn__T5P7S {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.ToggleButton_deleteBtn__T5P7S:active, .ToggleButton_deleteBtn__T5P7S:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.ToggleButton_deleteBtn__T5P7S svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.ToggleButton_deleteBtn__T5P7S:hover,
.ToggleButton_deleteBtn__T5P7S:active,
.ToggleButton_deleteBtn__T5P7S:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.ToggleButton_confirmBtn__NbQBi {
  background-color: #131F43;
}

.ToggleButton_confirmBtn__NbQBi:hover,
.ToggleButton_confirmBtn__NbQBi:active,
.ToggleButton_confirmBtn__NbQBi:focus {
  background-color: #131F43;
}

.ToggleButton_confirmBtn__NbQBi svg {
  top: 0;
}

.ToggleButton_delPopContainer__bvk45 .ToggleButton_modal-body__YPdm2 {
  padding: 25px;
  text-align: center;
}

.ToggleButton_delPopContainer__bvk45 .ToggleButton_delet_icon__xnDDd {
  margin-bottom: 11px;
}

.ToggleButton_delPopContainer__bvk45 p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.ToggleButton_arrowback__e-TLr svg {
  fill: #000;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_arrowback__e-TLr {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_arrowback__e-TLr svg {
  fill: #3b82f6;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_drpdwn_btn__3ckIW {
  background-color: #132337;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_empname__-nZNB {
  color: #92afd3 !important;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_navitemli__EcpRU a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_tabnavli__WFVt7 a.ToggleButton_settingsgeneral__Ht4wT,
.ToggleButton_bodythemedark__mk1cl .ToggleButton_tabnavli__WFVt7 a.ToggleButton_settingslinks__VyZug:hover {
  background-color: #3b82f6;
  color: #fff;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_tabnavli__WFVt7 a.ToggleButton_settingslinks__VyZug {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.ToggleButton_headerthemedark__6P1qs .ToggleButton_dropdown_menu_contain__tjeDc {
  background-color: #1c2e45;
  color: #fff;
}

.ToggleButton_headerthemedark__6P1qs .ToggleButton_dropdown_menu_contain__tjeDc ul li a,
.ToggleButton_headerthemedark__6P1qs .ToggleButton_dropdown_menu_contain__tjeDc .ToggleButton_dropdown_item__xy1l0,
.ToggleButton_headerthemedark__6P1qs .ToggleButton_dropdown_menu_contain__tjeDc .ToggleButton_dropdown_item__xy1l0 h5 {
  color: #fff;
}

.ToggleButton_headerthemedark__6P1qs .ToggleButton_dropdown_menu_contain__tjeDc ul li a:hover,
.ToggleButton_headerthemedark__6P1qs .ToggleButton_dropdown_menu_contain__tjeDc .ToggleButton_dropdown_item__xy1l0:hover {
  background-color: #132337;
  color: #fff;
}

.ToggleButton_dropdown_item__xy1l0:active {
  background-color: #F5F6FA;
}

.ToggleButton_profile_arrrow_dwn__GQMnz {
  stroke: #132337;
}

.ToggleButton_headerthemedark__6P1qs .ToggleButton_profile_arrrow_dwn__GQMnz {
  stroke: #fff;
}

.ToggleButton_dateinputbox1__\\+Vmha input,
.ToggleButton_dateinputbox1__\\+Vmha span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .ToggleButton_tableheadlight__HMlEb th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .ToggleButton_dashboard__6uIAT {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .ToggleButton_cont2__y79\\+w {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .ToggleButton_sectionright__jSHE2 {
    float: unset !important;
  }
  .ToggleButton_dashboard__6uIAT {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .ToggleButton_cont2__y79\\+w {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .ToggleButton_bodythemelight__xbVdb, .ToggleButton_bodythemedark__mk1cl {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .ToggleButton_exer_modal_contain__lh\\+AY .ToggleButton_modal-dialog__HyBM\\+ {
    max-width: 1055px;
  }
  .ToggleButton_delPopContainer__bvk45 .ToggleButton_modal-dialog__HyBM\\+ {
    max-width: 350px;
  }
}
.ToggleButton_activebtn__Q2Kd4 {
  border: none;
  color: #fff;
  background-color: #50cd89;
  width: 70px;
  border-radius: 34px;
  line-height: 25px;
}

.ToggleButton_inactivebtn__NGuUK {
  border: none;
  color: #dee2e6;
  background-color: #737a92;
  width: 70px;
  border-radius: 34px;
  line-height: 25px;
}

/* Basic Rules */
.ToggleButton_switch__6Kmug input {
  display: none;
}

.ToggleButton_switch__6Kmug {
  display: inline-block;
  width: 50px;
  height: 20px;
  margin: 2px;
  transform: translateY(50%);
  position: relative;
}

/* Style Wired */
.ToggleButton_slider__nic9a {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 30px;
  box-shadow: 0 0 0 1px #777, 0 0 1px #777;
  cursor: pointer;
  border: 4px solid transparent;
  overflow: hidden;
  transition: 0.2s;
}

.ToggleButton_slider__nic9a:before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background: #777;
  border-radius: 30px;
  transform: translateX(-30px);
  transition: 0.2s;
}

input:checked + .ToggleButton_slider__nic9a:before {
  transform: translateX(30px);
  background: limeGreen;
}

input:checked + .ToggleButton_slider__nic9a {
  box-shadow: 0 0 0 2px limeGreen, 0 0 2px limeGreen;
}

/* Style Flat */
.ToggleButton_switch__6Kmug.ToggleButton_flat__OIQaE .ToggleButton_slider__nic9a {
  box-shadow: none;
}

.ToggleButton_switch__6Kmug.ToggleButton_flat__OIQaE .ToggleButton_slider__nic9a:before {
  background: #FFF;
}

.ToggleButton_switch__6Kmug.ToggleButton_flat__OIQaE input:checked + .ToggleButton_slider__nic9a:before {
  background: white;
}

.ToggleButton_switch__6Kmug.ToggleButton_flat__OIQaE input:checked + .ToggleButton_slider__nic9a {
  background: limeGreen;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/ToggleButton/ToggleButton.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAmDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,2BAAA;EACA,gBAAA;ACzEF;;AD2EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACxEF;;AD0EA;;;EAGE,yBAlEoB;ACLtB;;ADyEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACtEF;;ADyEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAzHO;EA0HP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACpEF;;AD0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACvEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBAjGY;ACwBd;;AD4EA;;CAAA;AAGA;EACE,sBAxGY;EAyGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAvHgB;EAwHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBApHY;AC4Cd;;AD2EA;EACE,yBAnIgB;AC2DlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAxIY;ACiEd;;ADyEA;EACE,yBAtJgB;ACgFlB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAvKsB;EAwKtB,cAlLkB;AC4GpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAlNc;AC6IhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBA3Nc;ACsJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBA1MsB;EA2MtB,WAlMY;AC6Hd;;ADwEA;;CAAA;AAGA;EACE,cAtMe;ACiIjB;;ADwEA;EACE,cA1Me;ACqIjB;;ADwEA;;CAAA;AAGA;EACE,sBApNY;EAqNZ,YAAA;ACrEF;;ADwEA;EACE,yBApOgB;EAqOhB,WA1NY;EA2NZ,YAAA;ACrEF;;ADuEA;EACE,cA3Ne;ACuJjB;;ADuEA;;CAAA;AAGA;EACE,yBAnRc;EAoRd,8BAAA;ACpEF;;ADsEA;EACE,WAzOY;ACsKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAvPkB;EAwPlB,WAhQY;ACkMd;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBA9QY;ACoNd;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cApRe;AC0NjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA/SY;EAgTZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBA5SkB;EA6SlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAtTa;AC6PjB;;AD8DA;;CAAA;AAGA;EACE,yBArUgB;AC0QlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBApVoB;EAqVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAxVY;AC8Rd;;AD6DA;EACE,yBApVkB;AC0RpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBArWY;AC0Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA9WY;ACmTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAvXY;AC4Td;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAhYY;ACqUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WA3YY;ACgVd;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cArZe;AC4VjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBAzbkB;EA0blB,WAzaY;AC+Wd;;AD4DA;EACE,yBA7bkB;EA8blB,WA7aY;ACoXd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBA1ckB;ACiZpB;;AD4DA;EACE,yBA7cwB;ACoZ1B;;AD4DA;EACE,WAjcY;EAkcZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAxdkB;AC+ZpB;;AD6DA;EACE,yBAvdgB;AC6ZlB;;AD6DA;EACE,eAAA;EACA,gBArgBc;EAsgBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAngBc;EAogBd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAzgBc;EA0gBd,WA5dY;ACmad;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WAleY;EAmeZ,yBA9fY;EA+fZ,YAAA;EACA,eAAA;EACA,gBA1hBc;ACiehB;;AD4DA;EACE,yBArgBY;AC4cd;;AD2DA;EACE,yBA9fkB;ACscpB;;AD0DA;EACE,yBAhgBwB;ACyc1B;;AD0DA;EACE,cAtgBiB;AC+cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA/fY;EAggBZ,yBA3hBY;EA4hBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA/hBW;EAgiBX,WA5gBY;EA6gBZ,eAAA;EACA,gBAlkBc;EAmkBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBAziBW;EA0iBX,WAthBY;EAuhBZ,eAAA;EACA,gBA5kBc;EA6kBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA/jBW;EAgkBX,WA5iBY;EA6iBZ,YAAA;ACxDF;;AD2DA;EACE,yBA/lBc;ACuiBhB;;AD2DA;;;EAGE,yBArmBc;AC6iBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCAnmBc;EAomBd,cAxmBkB;AC8iBpB;;AD6DA;EACE,aA5mBkB;ACkjBpB;;AD6DA;EACE,yBAxmBgB;AC8iBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAvmBY;AC6iBd;;AD6DA;;EAEE,yBA7nBkB;EA8nBlB,WA7mBY;ACmjBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlnBY;ACyjBd;;AD4DA;EACE,yBA/nBsB;EAgoBtB,WAvnBY;AC8jBd;;AD4DA;;;EAGE,WA7nBY;ACokBd;;AD4DA;;EAEE,yBA7oBgB;EA8oBhB,WAnoBY;AC0kBd;;AD4DA;EACE,yBAtrBO;AC6nBT;;AD4DA;EACE,eAtpBgB;AC6lBlB;;AD4DA;EACE,YA/oBY;ACslBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AA1sBA;EACG,YAAA;EACA,WD2DW;EC1DX,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AA4sBH;;AAxsBA;EACE,YAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AA2sBF;;AApsBA,gBAAA;AACA;EACE,aAAA;AAusBF;;AArsBA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;AAwsBF;;AAtsBA,gBAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACC,gBAAA;AAysBH;;AAvsBA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AA0sBF;;AAvsBA;EACE,2BAAA;EACA,qBAAA;AA0sBF;;AAxsBA;EACE,kDAAA;AA2sBF;;AAxsBA,eAAA;AACA;EACA,gBAAA;AA2sBA;;AAzsBA;EACA,gBAAA;AA4sBA;;AA1sBA;EACA,iBAAA;AA6sBA;;AA3sBA;EACA,qBAAA;AA8sBA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #DBEAFE;  \n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #D1FAE5;  \n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FEF3C7;  \n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #E9D5FF; \n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon1-color: #3B82F6;  \n$cardIcon2-color: #10B981;  \n$cardIcon3-color: #F59E0B;  \n$cardIcon4-color: #8B5CF6;  \n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"/src/styles/Variables/Variables.scss\";\n\n.activebtn{\n   border: none;\n   color: $white-color;\n   background-color: #50cd89;\n   width: 70px;\n   border-radius: 34px;\n   line-height: 25px;\n    \n  //  box-shadow: 0 1px 2px #babfc7;\n}\n.inactivebtn{\n  border: none;\n  color: #dee2e6;\n  background-color: #737a92;\n  width: 70px;\n  border-radius: 34px;\n  line-height: 25px;\n   \n  // box-shadow: 0 1px 2px #babfc7;\n}\n\n\n\n/* Basic Rules */\n.switch input { \n  display:none;\n}\n.switch {\n  display:inline-block;\n  width:50px;\n  height:20px;\n  margin:2px;\n  transform:translateY(50%);\n  position:relative;\n}\n/* Style Wired */\n.slider {\n  position:absolute;\n  top:0;\n  bottom:0;\n  left:0;\n  right:0;\n  border-radius:30px;\n  box-shadow:0 0 0 1px #777, 0 0 1px #777;\n  cursor:pointer;\n  border:4px solid transparent;\n  overflow:hidden;\n   transition:.2s;\n}\n.slider:before {\n  position:absolute;\n  content:\"\";\n  width:100%;\n  height:100%;\n  background:#777;\n  border-radius:30px;\n  transform:translateX(-30px);\n  transition:.2s;\n}\n\ninput:checked + .slider:before {\n  transform:translateX(30px);\n  background:limeGreen;\n}\ninput:checked + .slider {\n  box-shadow:0 0 0 2px limeGreen,0 0 2px limeGreen;\n}\n\n/* Style Flat */\n.switch.flat .slider {\nbox-shadow:none;\n}\n.switch.flat .slider:before {\nbackground:#FFF;\n}\n.switch.flat input:checked + .slider:before {\nbackground:white;\n}\n.switch.flat input:checked + .slider {\nbackground:limeGreen;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `ToggleButton_dashboard__6uIAT`,
	"dashboardContain": `ToggleButton_dashboardContain__G3Iom`,
	"bodythemedark": `ToggleButton_bodythemedark__mk1cl`,
	"cont2": `ToggleButton_cont2__y79+w`,
	"top_header": `ToggleButton_top_header__Cqcd3`,
	"top_header_inner": `ToggleButton_top_header_inner__Uy0t5`,
	"subLink": `ToggleButton_subLink__qrmnO`,
	"footer": `ToggleButton_footer__k+jkH`,
	"bodythemelight": `ToggleButton_bodythemelight__xbVdb`,
	"headerthemelight": `ToggleButton_headerthemelight__KBxNK`,
	"headerthemedark": `ToggleButton_headerthemedark__6P1qs`,
	"menuthemelight": `ToggleButton_menuthemelight__Um682`,
	"menuthemedark": `ToggleButton_menuthemedark__VX9a7`,
	"menulinklight": `ToggleButton_menulinklight__fo-41`,
	"menulinkdarkSelected": `ToggleButton_menulinkdarkSelected__v5Q2p`,
	"menulinklightSelected": `ToggleButton_menulinklightSelected__p-O0O`,
	"menulinkdark": `ToggleButton_menulinkdark__H9koF`,
	"sub_arrow": `ToggleButton_sub_arrow__3tNzG`,
	"headinglight": `ToggleButton_headinglight__46yE4`,
	"headingdark": `ToggleButton_headingdark__7Kdz4`,
	"searchboxlight": `ToggleButton_searchboxlight__IgyaT`,
	"searchboxdark": `ToggleButton_searchboxdark__s-55U`,
	"tableheadlight": `ToggleButton_tableheadlight__HMlEb`,
	"tableheaddark": `ToggleButton_tableheaddark__CqMs1`,
	"table": `ToggleButton_table__gUUsS`,
	"table-borderless": `ToggleButton_table-borderless__eH6QQ`,
	"left-section": `ToggleButton_left-section__meX0e`,
	"tablebodylight": `ToggleButton_tablebodylight__CqriS`,
	"tablebodydark": `ToggleButton_tablebodydark__9ZXJj`,
	"paginationlight": `ToggleButton_paginationlight__BaJSK`,
	"paginationdark": `ToggleButton_paginationdark__fwOiV`,
	"formthemelight": `ToggleButton_formthemelight__WUeV2`,
	"formthemedark": `ToggleButton_formthemedark__CPoir`,
	"viewformlight": `ToggleButton_viewformlight__kVJ4n`,
	"permissionboxlight": `ToggleButton_permissionboxlight__gxJYP`,
	"permissionboxdark": `ToggleButton_permissionboxdark__HAgO2`,
	"errormsgclr": `ToggleButton_errormsgclr__Lb-s-`,
	"graphclrlight": `ToggleButton_graphclrlight__CuUx3`,
	"graphclrdark": `ToggleButton_graphclrdark__pHaGO`,
	"card1bglight": `ToggleButton_card1bglight__cN6YD`,
	"card1bgdark": `ToggleButton_card1bgdark__dKi5L`,
	"card2bglight": `ToggleButton_card2bglight__Yvkl4`,
	"card2bgdark": `ToggleButton_card2bgdark__0vB9u`,
	"card3bglight": `ToggleButton_card3bglight__Kqqmv`,
	"card3bgdark": `ToggleButton_card3bgdark__siCXv`,
	"card4bglight": `ToggleButton_card4bglight__yPfuZ`,
	"card4bgdark": `ToggleButton_card4bgdark__KQ3Jn`,
	"actionbtnlight": `ToggleButton_actionbtnlight__74r4t`,
	"actionbtndark": `ToggleButton_actionbtndark__n+blE`,
	"profiledropdownlight": `ToggleButton_profiledropdownlight__i75Et`,
	"profiledropdowndark": `ToggleButton_profiledropdowndark__ydRyq`,
	"settingsection": `ToggleButton_settingsection__qgzvg`,
	"addform": `ToggleButton_addform__P2xOP`,
	"savebtn": `ToggleButton_savebtn__TXAnP`,
	"profile_conatiner": `ToggleButton_profile_conatiner__mcUet`,
	"ag-theme-alpine": `ToggleButton_ag-theme-alpine__6B+er`,
	"ag-row": `ToggleButton_ag-row__oz+e+`,
	"formbtn": `ToggleButton_formbtn__PHUbN`,
	"resetbtn": `ToggleButton_resetbtn__V-tkS`,
	"addBtn": `ToggleButton_addBtn__SvaL8`,
	"addbtnlight": `ToggleButton_addbtnlight__hhs0R`,
	"addbtndark": `ToggleButton_addbtndark__MRXDH`,
	"cust_addBtn": `ToggleButton_cust_addBtn__Gm3LP`,
	"deleteBtn": `ToggleButton_deleteBtn__T5P7S`,
	"confirmBtn": `ToggleButton_confirmBtn__NbQBi`,
	"delPopContainer": `ToggleButton_delPopContainer__bvk45`,
	"modal-body": `ToggleButton_modal-body__YPdm2`,
	"delet_icon": `ToggleButton_delet_icon__xnDDd`,
	"arrowback": `ToggleButton_arrowback__e-TLr`,
	"drpdwn_btn": `ToggleButton_drpdwn_btn__3ckIW`,
	"empname": `ToggleButton_empname__-nZNB`,
	"navitemli": `ToggleButton_navitemli__EcpRU`,
	"tabnavli": `ToggleButton_tabnavli__WFVt7`,
	"settingsgeneral": `ToggleButton_settingsgeneral__Ht4wT`,
	"settingslinks": `ToggleButton_settingslinks__VyZug`,
	"dropdown_menu_contain": `ToggleButton_dropdown_menu_contain__tjeDc`,
	"dropdown_item": `ToggleButton_dropdown_item__xy1l0`,
	"profile_arrrow_dwn": `ToggleButton_profile_arrrow_dwn__GQMnz`,
	"dateinputbox1": `ToggleButton_dateinputbox1__+Vmha`,
	"sectionright": `ToggleButton_sectionright__jSHE2`,
	"exer_modal_contain": `ToggleButton_exer_modal_contain__lh+AY`,
	"modal-dialog": `ToggleButton_modal-dialog__HyBM+`,
	"activebtn": `ToggleButton_activebtn__Q2Kd4`,
	"inactivebtn": `ToggleButton_inactivebtn__NGuUK`,
	"switch": `ToggleButton_switch__6Kmug`,
	"slider": `ToggleButton_slider__nic9a`,
	"flat": `ToggleButton_flat__OIQaE`
};
export default ___CSS_LOADER_EXPORT___;
